import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { HelpArticleDto, GET_HELP_ARTICLES_QUERY_KEY, GET_HELP_ARTICLE_QUERY_KEY } from './useHelpArticles';

export type UpdateHelpArticleInput = {
  title?: string;
  slug?: string;
  contentKey?: string;
  excerpt?: string;
  content?: string;
  language?: string;
  status?: string;
  categoryId?: string;
  coverImage?: string;
  sortOrder?: number;
};

export const useUpdateHelpArticle = (onSuccess: (data: HelpArticleDto) => void) => {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...input }: UpdateHelpArticleInput & { id: string }) =>
      client.fetchApi<HelpArticleDto, UpdateHelpArticleInput>({ endpoint: `help/admin/articles/${id}`, method: 'PUT', body: input }),
    onSuccess: (data) => {
      queryClient.invalidateQueries(GET_HELP_ARTICLES_QUERY_KEY);
      queryClient.setQueryData(GET_HELP_ARTICLE_QUERY_KEY(data.id), data);
      onSuccess(data);
    },
  });
};
